import moment from 'moment';
import React, { Component, Fragment } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import './customReactDatepicker.css';
import './reports.css';
import DailyEditCheckReportIcon from './../../../assets/img/mm/icon-6.png';
const enumMealType = {
    lunch: 'Lunch',
    breakfast: 'Breakfast',
    milk: 'Milk',
    snack: 'Snack',
    dinner: 'Dinner'
}
class DailyEditCheckListReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: props.reportDefaultDate || new Date(),
            mealType: enumMealType.lunch,
            isState: false,
            data: [],
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillUnmount = () => {
        // this.bindData();
    }
    bindData = () => {
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const s_d_id = schoolID > 0 ? schoolID : districtID;
        const isSchool = schoolID > 0 ? true : false;
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        let firstDay = moment(this.state.date).startOf('M').format('YYYY-MM-DD') + "T00:00:00";
        let lastDay = moment(this.state.date).endOf('M').format('YYYY-MM-DD') + "T23:59:59";
        const yearMonth = moment(this.state.date).format('YYYYMM');
        let _url = '/reports/auditDailyEditCheck?districtId=' + districtID + '&mealSchoolId=' + schoolID
            + '&startDate=' + moment(firstDay, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(lastDay, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss") + '&itemType=' + (this.state.mealType) +
            '&schoolYear=' + schoolYear + '&yearMonth=' + yearMonth
            + '&isState=' + (this.isStateEnabled() && this.state.isState) + '&access_token='
        this.setState({ loading: true })
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 417 || response.status === 422) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                _addNotificationError(res.statusMessage, this.props)
                throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                throw Error(res.statusMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "DailyEditCheckReport";
            showFile(blob, filename);
            this.setState({ loading: false })
        }).catch((error) => {
            let msg = ''
            if (typeof error === 'string') {
                msg = error;
            } else {
                msg = error.message;
            }
            _addNotificationError(msg, this.props);
            this.setState({ loading: false })
        }
        );
    }
    // State report is offered only when state income eligibility is enabled for the selected school,
    // or for any school in the district when generating for all schools
    isStateEnabled = () => {
        const schools = this.state.userInfo.schools || [];
        const schoolID = parseInt(this.props.selectSchool);
        if (schoolID > 0) {
            const school = schools.find(s => parseInt(s.schoolId) === schoolID);
            return !!(school && school.stateIncomeEligEnabled);
        }
        return schools.some(s => s.stateIncomeEligEnabled);
    }
    render() {
        const { date, mealType, isState } = this.state;
        const stateEnabled = this.isStateEnabled();
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={DailyEditCheckReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Daily Edit Check Report</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                                {stateEnabled ? <div className="row form-group">
                                    <label class="col-sm-12 control-label">Report Type</label>
                                    <div className="col-sm-12">
                                        <select className='form-control form-control-sm' value={isState ? 'state' : 'federal'} onChange={(e) => {
                                            this.setState({ isState: e.target.value === 'state' })
                                        }}>
                                            <option value='federal'>Federal</option>
                                            <option value='state'>State</option>
                                        </select>
                                    </div>
                                </div> : null}
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">Report for</label>
                                    <div className="col-sm-12">
                                        <select className='form-control form-control-sm' value={mealType} onChange={(e) => {
                                            this.setState({ mealType: e.target.value })
                                        }}>
                                            {
                                                Object.keys(enumMealType).map((key, i) => {
                                                    return <option key={i} value={enumMealType[key]}>{enumMealType[key]}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <label class="col-sm-12 control-label">Month</label>
                                    <div className="col-sm-12">
                                        <DatePicker wrapperClassName="fullWidthDatepicker"
                                            selected={date}
                                            dateFormat="MM/yyyy"
                                            showMonthYearPicker
                                            onChange={(date) => {
                                                this.setState({ date: date });
                                            }} className='form-control form-control-sm' />
                                    </div>
                                </div>
                            </div>
                            <div className='reportCard-widget-meeting-action'>
                                <div className="form-group">
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px' }} onClick={() => {
                                        this.bindData()
                                    }}>
                                        Download Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default DailyEditCheckListReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/dailyEditCheckList.js